import React from 'react';
import Page from '../../layout/Page';
import LoyaltyPoints from './LoyaltyPoints';
import RoleProtected, { userRoles } from '../../RoleProtected';
import { HasFeature, Features } from '../../RequireFeature';

const LoyaltyPointsPage = () => {
    const hasAwardEnhancement = HasFeature(Features.AwardEnhancement);
    if (hasAwardEnhancement) return null;

    return (
        <RoleProtected roles={userRoles.accountConfiguration}>
            <Page title='Loyalty Points' icon='mobile'>
                <LoyaltyPoints />
            </Page>
        </RoleProtected>
    );
}

export default LoyaltyPointsPage;
